import { render } from "./Redes.vue?vue&type=template&id=45af22c4&scoped=true"
import script from "./Redes.vue?vue&type=script&lang=js"
export * from "./Redes.vue?vue&type=script&lang=js"

import "./Redes.vue?vue&type=style&index=0&id=45af22c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45af22c4"]])

export default __exports__